import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { initializeTheme } from '../utils/themeManager';

const ThemeInitializer = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // Don't initialize theme until auth status is determined
    if (isLoading) return;

    const initTheme = async () => {
      if (isAuthenticated && user?.userSettings) {
        // User is authenticated - use their saved theme preference
        await initializeTheme(user.userSettings);
      } else {
        // User is not authenticated - use localStorage or default
        await initializeTheme();
      }
    };

    initTheme();
  }, [user, isAuthenticated, isLoading]);

  return children;
};

export default ThemeInitializer;